module.exports = __webpack_public_path__ + "img/frenteBusNoMotorist.7b09c35c.svg";